import { selectApiData } from 'util/selector/apiSelector';

import { WithData } from 'api/interfaces';
import { AxiosInstance } from 'axios';

import {
  DeliveryStatisticModel,
  mapDeliveryStatisticDtoToModel,
} from './dto/DeliveryStatistic.dto';
import { JobDto } from './dto/JobExtended.dto';

export class DeliveryStatisticApi {
  constructor(private client: AxiosInstance) {}

  fetch(id: string, daysLimit: number = 0): Promise<DeliveryStatisticModel[]> {
    const query = daysLimit !== 0 ? `daysLimit=${daysLimit}` : '';

    return this.client
      .get(`/api/v1/distribution/${id}/delivery-stats?${query}`)
      .then(selectApiData)
      .then((entries) => entries.map(mapDeliveryStatisticDtoToModel));
  }

  refresh(distributionId: string, emailId: number): Promise<number> {
    return this.client
      .post<
        WithData<JobDto>
      >(`/api/v1/distribution/${distributionId}/email-template/${emailId}/update-statuses`)
      .then((response) => selectApiData(response).id);
  }
}
